import React from 'react';
import cn from 'classnames';
import { isNil } from 'lodash';
import { routes } from "../../../constants";
import IconSVG from "../../../styles/svg-icons";
import { OnHoverTooltip } from "../../common/OnHoverTooltip";
import { FeatureLink } from '../../access/FeatureLink';
import { BlockedFeatureContext } from '../../access/BlockedFeatureContext';

interface TransactionHistoryProps {
    referenceName: string;
    dealReferenceName: string;
    target?: React.HTMLAttributeAnchorTarget;
    overlayText?: string;
    label?: boolean;
    labelText?: string;
    icon?: boolean;
    version?: number;
    disabled?: boolean;
    onClick?: () => void;
    className?: string;
}

export const TransactionHistoryLink = ({
    referenceName,
    dealReferenceName,
    target = '_blank',
    overlayText = 'Transaction History',
    label = true,
    icon = true,
    labelText = "Trans History",
    disabled = false,
    version,
    onClick,
    className = "btn-link btn-link-history"
}: TransactionHistoryProps) => {
    const isBlocked = React.useContext(BlockedFeatureContext);

    return (
        <OnHoverTooltip
            disabled={isBlocked}
            overlay={label ? overlayText : `Transaction History: V.${version}`}
            wrapperClass={cn({ 'history-box': label })}
        >
            <FeatureLink
                path={routes.transactionHistoryUrl(referenceName, dealReferenceName)}
                onClick={onClick}
                className={className}
                target={target}
                disabled={disabled}
            >
                {icon && <IconSVG name="timeline" width={16} height={16} />}
                {label && <span>{labelText}</span>}
                {label && !isNil(version) && <span className="history-version">&nbsp;V.{version}.</span>}
            </FeatureLink>
        </OnHoverTooltip>
    );
}
